export const projectsWidgets = [
  {
    id: 1,
    feaIcon: "briefcase",
    feaIconClass: "primary",
    label: "Active Projects",
    badgeClass: "danger",
    icon: "ri-arrow-down-s-line",
    percentage: "5.02 %",
    caption: "Projects this month",
    subCounter: [{ id: 1, counter: 825, suffix: "" }]
  },
  {
    id: 2,
    feaIcon: "award",
    feaIconClass: "warning",
    label: "New Leads",
    badgeClass: "success",
    icon: "ri-arrow-up-s-line",
    percentage: "3.58 %",
    caption: "Leads this month",
    subCounter: [{ id: 1, counter: 7522, suffix: "" }]
  },
  {
    id: 3,
    feaIcon: "clock",
    feaIconClass: "info",
    label: "Total Hours",
    badgeClass: "danger",
    icon: "ri-arrow-down-s-line",
    percentage: "10.35 %",
    caption: "Work this month",
    subCounter: [{ id: 1, counter: 168, suffix: "h" }, { id: 1, counter: 40, suffix: "m" }]
  }
];

export const allProjectData = [{
  name: 'Number of Projects',
  type: 'bar',
  data: [34, 65, 46, 68, 49, 61, 42, 44, 78, 52, 63, 67]
}, {
  name: 'Revenue',
  type: 'area',
  data: [89.25, 98.58, 68.74, 108.87, 77.54, 84.03, 51.24, 28.57, 92.57, 42.36, 88.51, 36.57]
}, {
  name: 'Active Projects',
  type: 'bar',
  data: [8, 12, 7, 17, 21, 11, 5, 9, 7, 29, 12, 35]
}];

export const monthProjectData = [{
  name: 'Number of Projects',
  type: 'bar',
  data: [14, 45, 56, 78, 79, 81, 62, 44, 88, 52, 63, 87]
}, {
  name: 'Revenue',
  type: 'area',
  data: [119.25, 128.58, 148.74, 148.87, 17.54, 154.03, 71.24, 78.57, 92.57, 42.36, 88.51, 76.57]
}, {
  name: 'Active Projects',
  type: 'bar',
  data: [18, 22, 17, 47, 71, 31, 5, 9, 7, 29, 22, 75]
}];

export const halfyearProjectData = [{
  name: 'Number of Projects',
  type: 'bar',
  data: [34, 75, 66, 78, 29, 41, 32, 44, 58, 22, 43, 77]
}, {
  name: 'Revenue',
  type: 'area',
  data: [109.25, 48.58, 38.74, 78.87, 57.54, 44.03, 21.24, 18.57, 92.57, 42.36, 48.51, 56.57]
}, {
  name: 'Active Projects',
  type: 'bar',
  data: [38, 22, 27, 47, 61, 41, 15, 89, 27, 49, 32, 75]
}];

export const yearProjectData = [{
  name: 'Number of Projects',
  type: 'bar',
  data: [14, 45, 16, 38, 29, 21, 12, 14, 58, 22, 23, 47]
}, {
  name: 'Revenue',
  type: 'area',
  data: [59.25, 68.58, 48.74, 78.87, 57.54, 64.03, 21.24, 18.57, 52.57, 22.36, 68.51, 16.57]
}, {
  name: 'Active Projects',
  type: 'bar',
  data: [38, 32, 27, 37, 41, 51, 35, 29, 17, 59, 32, 45]
}];